import { gql } from "@/__generated__/gql";

export const BULK_MESSAGES_QUERY = gql(`
  query OrganizationBulkMessages(
    $orgId: ID!,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int,
    $sendStatus: [BulkMessageSendStatusEnum!]!,
    $campaignType: [BulkMessageCampaignTypeEnum!]!,
    $ordering: [BulkMessageOrderingInput!]!,
    $sentFrom: [BulkMessageSentFromFilterInput!],
    $createdBy: [ID!],
  ) {
    node(id: $orgId) {
      ... on Organization {
        id
        __typename
        bulkMessages(
          first: $first
          last: $last
          after: $after
          before: $before
          sendStatus: $sendStatus
          campaignType: $campaignType
          sentFrom: $sentFrom
          createdBy: $createdBy
          ordering: $ordering
        ) {
          edges {
            node {
            id
            name
            audienceReach(first: 3) {
              nodes {
                firstName
                lastName
                profilePhoto {
                  url(size: 24)
                }
              }
              totalCount
            }
            createdAt
            createdBy {
              id
              firstName
              lastName
              uuid
            }
            campaignType
            senderType
            startSendingAt
            stopSendingAt
            sentTo(first: 3) {
              nodes {
                firstName
                lastName
                profilePhoto {
                  url(size: 24)
                }
              }
              totalCount
            }
            sentFrom {
              firstName
              email
              lastName
              profilePhoto {
                id
                url(size: 24)
              }
            }
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
        totalCount
      }
    }
  }
  }
`);
